// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useState } from 'react'
import { IMG_TOP_BUFFER, DARKER_SAVANT_GREEN } from './utils/constants.ts'
import { useDimensions } from './utils/responsive-dimensions.tsx'

function SettingsToggle() {
    const { SETTINGS_MENU_DIM } = useDimensions()
    const [hovered, setHovered] = useState(false)

    return (
        <g
            id="comp-tool-settings-toggle"
            transform={`translate(${IMG_TOP_BUFFER}, ${IMG_TOP_BUFFER})`}
            style={{ cursor: 'pointer', opacity: 0.5 }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={() => {
                const popover = document.getElementById('settings-popover')
                if (popover && 'showPopover' in popover) {
                    popover.showPopover()
                }
            }}
        >
            <rect
                x={0}
                y={0}
                width={SETTINGS_MENU_DIM}
                height={SETTINGS_MENU_DIM}
                rx={2}
                fill={hovered ? DARKER_SAVANT_GREEN : '#ffffff'}
                stroke={DARKER_SAVANT_GREEN}
                strokeWidth={1}
                style={{ transition: 'fill 0.2s ease-in-out' }}
            />
            <svg
                x={0}
                y={0}
                width={SETTINGS_MENU_DIM}
                height={SETTINGS_MENU_DIM}
                viewBox="-4 -4 32 32"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    stroke={hovered ? '#ffffff' : DARKER_SAVANT_GREEN}
                    fill="none"
                    style={{
                        transition: 'stroke 0.2s ease-in-out',
                    }}
                />
            </svg>
        </g>
    )
}

export default SettingsToggle
